import { FC, useEffect, useState } from 'react'
import { useLang } from './Metronici18n'
import { IntlProvider } from 'react-intl'
import { WithChildren } from '../helpers'
import { fetchData } from '../../reusable'

const I18nProvider: FC<WithChildren> = ({ children }) => {
  const locale = useLang()
  const [messages, setMessages] = useState<any>(null)

  useEffect(() => {
    if(locale){
      const fetchMessages = async () => {
        try {
          const param = {
            code: locale
          }
          const response = await fetchData('public/language', param)
          setMessages(response)
        } catch (err) {
          setMessages({})
        }
      }
      fetchMessages()
    }
  }, [locale])

  return (
    <IntlProvider locale={locale} messages={messages} onError={(err) => {
      if (
        process.env.NODE_ENV === 'development' &&
        err.code === 'MISSING_TRANSLATION'
      ) {
        // console.warn('[Missing translation]', err.message);
      }
    }}>
      {children}
    </IntlProvider>
  )
}

export { I18nProvider }
